import React, { useEffect } from 'react'
import ReactTagInput from '@pathofdev/react-tag-input'
import '@pathofdev/react-tag-input/build/index.css'

const TagsList = ({ value, onChange, label, testId, testIdIndex, ...restProps }) => {
    useEffect(() => {
        if (testId !== undefined) {
            document
                .getElementsByClassName('react-tag-input__input')[0]
                .setAttribute('data-testid', testId)

            const content = document.getElementsByClassName('react-tag-input__tag__content')
            const remove = document.getElementsByClassName('react-tag-input__tag__remove')
            if (content.length > 0) {
                for (let index = 0; index < content.length; index++) {
                    const c1 = content[index]
                    const r1 = remove[index]
                    c1.setAttribute('data-testid', `tag-${index}-value`)
                    r1.setAttribute('data-testid', `tag-${index}-remove`)
                }
            }
        }
    }, [onChange, testId, testIdIndex])

    return (
        <div
            className="form-group"
            data-testid={`${label.toLowerCase().replaceAll(' ', '-')}-section`}
        >
            {label && <label className="!mb-1">{label}</label>}
            <ReactTagInput tags={value} onChange={onChange} {...restProps} />
        </div>
    )
}

export default TagsList
